import { useEffect, useState } from "react";

/**
 * True when the viewport is below Tailwind's `md` breakpoint (768px).
 * Drives the desktop-shell ↔ mobile-shell swap in <Shell>. Uses matchMedia
 * with a listener so it reacts to rotation / window resize live.
 */
const QUERY = "(max-width: 767px)";

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() =>
    typeof window !== "undefined" ? window.matchMedia(QUERY).matches : false,
  );

  useEffect(() => {
    const mql = window.matchMedia(QUERY);
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mql.addEventListener("change", onChange);
    // Sync in case it changed between initial render and effect.
    setIsMobile(mql.matches);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
